export default __webpack_public_path__ + "static/media/open-a-i.efe763b7.svg";